module.exports = __webpack_public_path__ + "assets/toplay.ad099698.svg";